export default __webpack_public_path__ + "static/media/achievement_stickers.5d2ae5e2.mp3";